import { render, staticRenderFns } from "./LogsList.vue?vue&type=template&id=3ed62d14&lang=pug"
import script from "./LogsList.vue?vue&type=script&lang=ts"
export * from "./LogsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports